import React, { useEffect, useState } from "react";
import './Carousel.css';
import { useTranslation } from "react-i18next";
import { about, opportunity1, opportunity2, opportunity3, opportunity4, service1, service2, service3, service4, service5, service6, why1, why2, why3, why4, why5, why6, why7, why8, why9 } from "../../../assets/images/index";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import AOS from "aos";
import "aos/dist/aos.css"; // AOS stil dosyasını import ediyoruz

const opportunitiesData = [ 
  { id: 1, image: service1,  title: "Azərbaycanda Təcrübə İmkanları", description: "Xaricdən gələn həkimlər və tibb tələbələri üçün Azərbaycanda yüksək səviyyəli tibb müəssisələrində təcrübə keçmək imkanı yaradırıq. Bu, Azərbaycan səhiyyə sistemini tanımaq və yerli mütəxəssislərlə birgə işləmək şansı təqdim edir." },
  { id: 2, image: service2, title: "Xaricdə Təcrübə İmkanları", description: "Azərbaycanın həkimləri və tibb tələbələri üçün beynəlxalq klinikalar və tibbi mərkəzlərdə təcrübə keçmək imkanı təqdim edirik. Bu proqram qlobal səhiyyə standartlarını öyrənməyə və beynəlxalq təcrübə qazanmağa imkan verir." },
  { id: 3, image: service3, title: "Qlobal Sanatoriya Şəbəkəsi", description: "Dünyanın müxtəlif ölkələrində yerləşən sanatoriya və sağlamlıq mərkəzləri ilə əməkdaşlıq quraraq xəstələr üçün müalicəvi istirahət imkanları yaradırıq. Rahatlıq və sağlamlıq arasında balans qurmaq istəyənlər üçün ideal seçimdir." },
  { id: 4, image: service4, title: "Azərbaycanda Tibbi Müalicə", description: "Xaricdən gələn xəstələr üçün Azərbaycanda yüksək səviyyəli müasir tibbi xidmətlər təklif edirik. Müxtəlif ixtisaslar üzrə ixtisaslaşmış həkimlərimiz və təchizatlı tibb mərkəzlərimiz ilə xəstələrin ehtiyaclarına uyğun həllər təqdim edirik." },
  { id: 5, image: service5, title: "Xaricdə Tibbi Müalicə", description: "Azərbaycanın hüdudlarından kənarda, dünyanın qabaqcıl tibbi müəssisələrində xəstələr üçün müalicə proseslərini təşkil edirik. Əməkdaşlıq etdiyimiz beynəlxalq klinikalar və mütəxəssislər vasitəsilə ən müasir tibbi xidmətlərdən faydalanmaq imkanı yaradırıq." },
  { id: 6, image: service6, title: "Qlobal Həkim Mübadiləsi", description: "Dünyanın müxtəlif ölkələri arasında həkimlərin təcrübə və bilik mübadiləsini təşkil edirik. Bu xidmət çərçivəsində həm xaricdən xaricə, həm də Azərbaycandan xaricə və xaricdən Azərbaycana həkimlər göndərərək beynəlxalq tibbi əməkdaşlığı genişləndiririk." },
];

const Opportunities = () => {

  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [showText, setShowText] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const slides = [
    { img: opportunity1 },
    { img: opportunity2 },
    { img: opportunity3 },
    { img: opportunity4 },
    { img: opportunity1 },
    { img: opportunity2 },
    { img: opportunity3 },
    { img: opportunity4 },
  ];

    useEffect(() => {
      AOS.init({
        duration: 1000, // Animasyon süresi (ms)
        once: true, // Sadece bir kere animasyonu tetikle
      });
    }, []);

  useEffect(() => {
    const textTimer = setTimeout(() => {
      setShowText(true);
    }, 500);

    const buttonTimer = setTimeout(() => {
      setShowButton(true);
    }, 1500);

    return () => {
      clearTimeout(textTimer);
      clearTimeout(buttonTimer);
    };
  }, [activeIndex]);

  return ( 
   <> 
   <div className="max-w-container mx-auto mt-[64px] md:mt-[104px] hidden md:block">
      <div className="flex items-center justify-between">
        <p className="text-[46px] font-medium">{t("Xidmətlərimiz")}</p>
        <a href='/services'>
          <button className='h-[51px] w-[164px] rounded-[12px] bg-[#FB8C00] text-white'>{t("Hamısına bax")}</button>
        </a>
      </div>
      <div className="grid grid-cols-3 mt-10 gap-10">
        {opportunitiesData.map((item) => (
          <div data-aos="fade-up" key={item.id} className="rounded-[20px] py-4 w-[400px] h-[220px] px-3 shadow bg-white">
            <img className="h-[50px] w-[50px] mx-auto" src={item.image} alt="Opportunity" />
            <div>
              <p className="mt-[12px] text-[22px] font-medium text-center">{t(item.title)}</p>
              <p className="mt-[12px] mb-[32px] text-center">
                {item.description.length > 80 ? t(item.description).slice(0,80) + '...' : t(item.description)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
     <div className="max-w-containerSm mx-auto mt-[64px] md:mt-[104px] block md:hidden">
     <p className="text-3xl font-medium text-center mb-8">{t("Xidmətlərimiz")}</p>
     <Swiper
      slidesPerView={1}
      spaceBetween={20}
      loop={true}
      autoplay={{
        delay: 4000,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: true,
      }}
      onSlideChange={(swiper) => {
        setShowText(false);
        setShowButton(false); 
        setActiveIndex(swiper.activeIndex);
      }}
      modules={[Autoplay, Pagination, Navigation]}
      className="mySwiper"
    >
      {opportunitiesData.map((slide, index) => (
        <SwiperSlide key={index}>
       <div key={slide.id} className="rounded-[20px] py-4 px-3 shadow bg-white">
            <img className="h-[50px] w-[50px] mx-auto" src={slide.image} alt="Opportunity" />
            <div>
              <p className="mt-[12px] text-[22px] font-medium text-center">{t(slide.title)}</p>
              <p className="mt-[12px] mb-[32px] text-center">
                {slide.description.length > 60 ? t(slide.description).slice(0,60) + '...' : t(slide.description)}
              </p>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
    <a href='/services'>
          <button className='h-[51px] w-full md:w-[164px] rounded-[12px] mt-8 bg-[#FB8C00] text-white'>{t("Hamısına bax")}</button>
        </a>
        </div>
    </>
  );
};

export default Opportunities;

